
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Trash2, Car } from "lucide-react";
import type { PackageData } from "@/pages/CreatePackage";

type Transport = PackageData['transport'][0];

interface PackageTransportListProps {
  packageTransport: Transport[];
  onRemoveTransport: (index: number) => void;
}

export const PackageTransportList = ({ packageTransport, onRemoveTransport }: PackageTransportListProps) => {
  if (packageTransport.length === 0) {
    return (
        <div className="text-center py-8 border-dashed border-2 rounded-lg">
            <Car className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-medium text-gray-900">لا توجد مواصلات</h3>
            <p className="mt-1 text-sm text-gray-500">ابدأ بإضافة تفاصيل المواصلات للعرض.</p>
        </div>
    );
  }

  const total = packageTransport.reduce((acc, t) => acc + t.price, 0);

  const transportTypeMap = {
    airport_transfer: 'استقبال وتوديع',
    city_transport: 'مواصلات بالمدينة',
    tour_transport: 'مواصلات جولة',
  };

  return (
    <div className="space-y-4 rounded-lg border p-4 mb-6">
      <h3 className="font-medium text-lg mb-2">المواصلات المضافة</h3>
      {packageTransport.map((transport, index) => (
        <div key={index} className="flex justify-between items-center bg-gray-50 p-3 rounded-md">
          <div className="flex items-center gap-4">
            <Car className="w-8 h-8 text-green-500 flex-shrink-0"/>
            <div>
                <p className="font-bold">{transport.vehicle} - <Badge variant="outline">{transportTypeMap[transport.type]}</Badge></p>
                <p className="text-sm text-gray-700 font-medium">{transport.from} ➔ {transport.to}</p>
                <p className="text-sm text-gray-600">{transport.date}</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <p className="font-semibold text-green-600">{transport.price.toLocaleString()} SAR</p>
            <Button variant="ghost" size="icon" onClick={() => onRemoveTransport(index)}>
              <Trash2 className="w-4 h-4 text-red-500" />
            </Button>
          </div>
        </div>
      ))}
      <div className="pt-4 mt-4 border-t text-right">
        <p className="font-bold text-xl">
          الإجمالي: {total.toLocaleString()} SAR
        </p>
      </div>
    </div>
  );
};
